import { AfterViewInit, Component, EventEmitter, HostListener, Input, OnChanges, OnDestroy, OnInit, Output, QueryList, SimpleChange, TemplateRef, ViewChild, ViewChildren } from '@angular/core';
import { BaseGridResponse, customFilterListModel, CustomGridButton, CustomGridColor, CustomGridImg, CustomgridOptions, CustomGridSorting, GridCheckBoxChangeData, GridColConfig, GridRowCheckboxChangeData, GridStatusIdb } from './custom-grid';
import * as _ from 'lodash';
import { CustomGridSService } from './custom-grid-s.service';
import { Subject, debounceTime, takeUntil } from 'rxjs';
import { trigger, transition, style, animate } from '@angular/animations';
import { CustomDialogComponent } from '../custom-dialog/custom-dialog.component';
import { environment } from 'src/environments/environment';
import { IdbDataResponse } from 'src/app/model/idb';
import { IdbService } from 'src/app/services/idb.service';
import { Session } from 'src/app/features/login/login';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { CustomDropDownListComponent } from '../custom-drop-down-list/custom-drop-down-list.component';
import { GlobalService } from 'src/app/services/global.service';
import { Sort } from '@angular/material/sort';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { fadeInOut, fadeInOutWithBlur, slideDownUp, slideDownUpFastLeave } from '../global-app-animations';


@Component({
  selector: 'app-custom-grid',
  templateUrl: './custom-grid.component.html',
  styleUrls: ['./custom-grid.component.scss'],
  animations: [
  fadeInOutWithBlur, slideDownUp, slideDownUpFastLeave
  ],
  standalone: false
})
export class CustomGridComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  //@ViewChild('Ctablel') tableEl: GridComponent | undefined;
  @ViewChild('mobileFiltering') dialogComp!: CustomDialogComponent; //mobile filters

  @ViewChildren(CustomDropDownListComponent) customComponentChildren?: QueryList<CustomDropDownListComponent>;

  @Input() dataSource: Array<any> = new Array<any>;
  @Input() gridColConfig!: Array<GridColConfig>;
  @Input() paging: boolean | undefined;
  @Input() template: TemplateRef<any> | undefined;
  @Input() tableOptions: CustomgridOptions | undefined;
  @Input() widthT: string | undefined;
  @Input() heightT: string | undefined;


  gridDataSource = new MatTableDataSource<any>();

  // outputs
  @Output() onActionBegin: EventEmitter<any> = new EventEmitter<any>();
  @Output() onRowDataBound: EventEmitter<any> = new EventEmitter<any>();
  @Output() onSwitchChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() onDropdownChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() onCheckBoxChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() onButtonClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() onDataSourceChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() onActionComplete: EventEmitter<any> = new EventEmitter<any>();
  @Output() onRowSelect: EventEmitter<any> = new EventEmitter<any>();
  @Output() onGridCheckBoxChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() onQueryCellInfo: EventEmitter<any> = new EventEmitter<any>();



  parsedData: BaseGridResponse | undefined;
  parsedOption: CustomgridOptions | undefined;
  totalRows: number = 0;
  parsedSwitchData: any;
  lastSession: boolean = false;
  showFilter: boolean = false;
  chooserOpen: boolean = false;

  displayedColumns: string[] = [];
  selection: any;

  // subscription for http call
  private theEnd$ = new Subject<void>();

  targetElement!: HTMLElement;

  filterSubject$: Subject<any> = new Subject<any>();
  filterButtonClass: string = 'icon-search'
  filterTooltip: string = ''

  ready: boolean = false;
  loading: boolean = false;

  getScreenWidth: number = 0;
  getScreenHeight: number = 0;
  rowMode: string = '';

  barcodeWidth: number = 1;

  // ordinamento tabella
  sortTaable: CustomGridSorting[] = [];

  // filtri tabella
  filterTable: customFilterListModel[] = [];
  currentSession?:string;
  sidebarOpen: boolean = true;
  isMobile: boolean = false;


  constructor(
    private customGridService: CustomGridSService,
    private idb: IdbService,
    private localStorageService: LocalStorageService,
    private globalService: GlobalService
  ) {

    this.currentSession = this.localStorageService.getGUID();
    
    if (this.widthT == undefined) {
      this.widthT = 'auto';
    }

    if (this.heightT == undefined) {
      this.heightT = 'auto';
    }

    // if(this.pageSettings == undefined) {
    //   //this.pageSettings = this.pageSettingsDefault;
    //   this.parsePage(this.pageSettingsDefault);
    // }

    if (this.paging == undefined) {
      this.paging = true;
    }

    if (this.dataSource == null) {
      this.dataSource = [];
      this.gridDataSource.data = [];
    }


  }

  @HostListener('window:resize', ['$event'])
  onWindowResize() {
    //this.barcodeWidth =

    this.getScreenWidth = window.innerWidth;
    this.getScreenHeight = window.innerHeight;
    if (this.getScreenHeight > this.getScreenWidth) {
      this.rowMode = "Vertical"
    } else {
      this.rowMode = "Orizzontal"
    }
  }

  ngOnDestroy(): void {
    //this.dataSource = [];
    //    this.theEnd$.next();
    this.theEnd$.complete();
    // unsubscribe observable and subscriptions
    this.theEnd$.next();
    this.theEnd$.complete();
  }

  showFilters(event: any) {
    this.showFilter = !this.showFilter;
    if (this.filterButtonClass == 'icon-close') {
      this.filterTable.forEach((x, index) => {
        this.filterTable[index].filterValue = '';
      })
      this.filterButtonClass = 'icon-search'
      //this.tableEl?.goToPage(1);
      let o = 1;
      let ps = 25;
      let ofs = (o - 1) * (ps);
      this.getDataLazy(ofs, ps, o, this.filterTable, this.sortTaable);


      /* if (this.rowMode == "Vertical") {
        this.dialogComp.close()
      }*/
    } else {
      this.filterButtonClass = 'icon-close'
      /* if (this.rowMode == "Vertical") {
        this.dialogComp.open()
      } */
    }
  }

  onDialogOpen(event: any) {
    event.preventFocus = true;
  }

  ngOnInit(): void {
    //this.onWindowResize();
    this.isMobile = this.globalService.isMobile();
    this.globalService.closeSidebar.pipe(takeUntil(this.theEnd$)).subscribe({
      next: () => {
        this.sidebarOpen = !this.sidebarOpen;
      }
    })

    this.globalService.isMobile$.pipe(takeUntil(this.theEnd$)).subscribe(val => {
      this.isMobile = val;
    });


    this.gridDataSource.paginator = this.paginator;

    setTimeout(() => {
      this.ready = true;
    }, 500)


    //this.pageSettings.pageCount = 2;

    //subject for filtering
    this.filterSubject$.pipe(debounceTime(500)).subscribe({
      next: (value: any) => {
        console.error("\n \n this is the value recived \n \n");
        console.log(value);
        console.log("loop all the filters value");
        this.filterTable.forEach((x, index) => {
          //console.log("this is index");
          //console.log(index)
          //console.log("this is this.filterTable[index]");
          //console.log(this.filterTable[index])

          //console.log("this is value.target");
          //console.log(value.target)
          console.log("looping, with index: " + index);
          console.log(x);
          console.log("🚀 ~CURRENT FILTER:", this.filterTable[index])

          if (x.filterDropdown == true) {
            if (x.field == value.field) {
              x.filterValue = value.id;
            }
          }

        })
        console.log("Dati da inviare");
        console.log(this.filterTable);




        //this.tableEl?.goToPage(1);
        let o = 1;
        let ps = 25;
        let ofs = (o - 1) * (ps);


        if (this.tableOptions!.notLazy != true) {
          this.getDataLazy(ofs, ps, o, this.filterTable, this.sortTaable);
        }

      }
    });
  }

  pushFilter(value: any) {
    console.warn("Start filter push");
    console.log(value)
    this.filterSubject$.next(value);
  }


  ngAfterViewInit(): void {

    //console.log(this.gridColConfig.map((c: GridColConfig) => c.field))
    this.displayedColumns = this.gridColConfig.filter(c => c.type != 'button' && c.visible != false).map((c: GridColConfig) => c.field);
    this.displayedColumns.push('actions')

    if (this.tableOptions?.gridName) {

      this.idb.getItemRow(environment.idbTables.GridStatus, `${this.tableOptions.gridName}-${this.currentSession}`).then((data: IdbDataResponse) => {


        this.filterTable = _.cloneDeep(data.item.filters);
        console.log("🚀 ~ file: custom-grid.component.ts:226 ~ CustomGridComponenasfdsgsgsfdsft ~ this.idb.getItemRow ~ this.filterTable:", this.filterTable)


        let showFilter: boolean = false;


        setTimeout(() => {
          for (let element of this.filterTable) {
            if (element.filterValue != '' && element.filterValue != undefined) {
              showFilter = true;
              //break;
            }
            /* if(element.type == 'dropdown') {
              if(this.customComponentChildren != undefined)  {
                this.customComponentChildren.forEach((data, index) => {

                  if (data.fieldName == this.filterTable[index].field) {
                    let xx: CustomDropDownListComponent | undefined = data.dropDownListObj;
                    //console.warn("\n \n THIS SHIT IS THE VALUE \n \n"+xx?.value);
                    if(data.dropDownListObj != undefined) {
                      //this.filterTable[index].filterValue = xx.value.toString();    
                      setTimeout(() => {
                        data.dropDownListObj!.value = element.filterValue || 0;
                        data.value = element.filterValue;
                      }, 10);                                        
                    }                
                  }

                });
              }              
            } */
          }

          if (showFilter == true) {

            this.showFilters(true);
            // RENDILO GLOBALE E IN BASE ALL'uTENTE AGGIUNGI UN VALORE ALL'oGGETTO DELLA GRID CHIAMATO NOME PER PRENDERE I DATI DELLA TABELLA  E AGIGUNGI L?UTENTE 
          }

          if (showFilter == true || data.item.currentPage != 1) {

            if (this.tableOptions!.notLazy != true) {
              let o = 1;
              let ps = 25;
              let ofs = (o - 1) * (ps);
              this.getDataLazy(ofs, ps, o, this.filterTable, this.sortTaable);

              //this.tableEl!.pageSettings = this.pageSettings || this.pageSettingsDefault;

            }

          } else {
            //this.tableEl!.pageSettings.currentPage = 1;
            if (this.tableOptions!.notLazy != true) {
              let o = 1;
              let ps = 25;
              let ofs = (o - 1) * (ps);
              this.getDataLazy(ofs, ps, o, this.filterTable, this.sortTaable);
            }
          }


          //  this.firstLoad = false;
        }, 100);
      }).catch(() => {
        //this.firstLoad = false;
        console.log("NO FILTERS IN IDB")

        this.gridColConfig.forEach(c => {
          if (c.filter != false) {
            this.filterTable.push(
              {
                field: c.field,
                filterValue: c.filterValue || '',
                type: c.type,
                name: c.name,
                dropdownFilterUrl: c.dropdownFilterUrl,
                filterDropdown: c.filterDropdown
              }
            );
            //console.log("🚀 ~ file: custom-grid.component.ts:444 ~ CustomGridComponent ~ this.idb.getItemRow ~ cccccccccc:", c)

          }
        });

        if (this.tableOptions!.notLazy != true) {
          let o = 1;
          let ps = 25;
          let ofs = (o - 1) * (ps);
          this.getDataLazy(ofs, ps, 1, this.filterTable, this.sortTaable);


        } else {
          this.getDataNotLazy(this.filterTable, this.sortTaable);
        }

      })
    } else {
      console.log("NO FILTERS IN IDB")

      this.gridColConfig.forEach(c => {
        if (c.filter != false) {
          this.filterTable.push(
            {
              field: c.field,
              filterValue: c.filterValue || '',
              type: c.type,
              name: c.name,
              dropdownFilterUrl: c.dropdownFilterUrl,
              filterDropdown: c.filterDropdown
            }
          );
          //console.log("🚀 ~ file: custom-grid.component.ts:444 ~ CustomGridComponent ~ this.idb.getItemRow ~ cccccccccc:", c)

        }
      });

      if (this.tableOptions!.notLazy != true) {
        let o = 1;
        let ps = 25;
        let ofs = (o - 1) * (ps);
        this.getDataLazy(ofs, ps, 1, this.filterTable, this.sortTaable);

      } else {
        this.getDataNotLazy(this.filterTable, this.sortTaable);
      }
    }



    //set filterTable fields

    /*this.customGridService.getLazyData(this.tableOptions!.apiCallurl,ofs,ps).subscribe({
      next: (data: Array<any>) => {
        if(//this.tableEl != undefined){
          //this.tableEl!.dataSource = data;
        }
        this.dataSource = data;
      },
      error: () => {

      },
      complete: () => {

      }
    });*/

    ////this.tableEl!.refresh();
    //setTimeout(() => {

    //}, 0);

    console.warn("\n Tabella aggiornata! \n");
    //console.log(this.tableEl?.pageSettings);
  }

  resetTable() {
    //this.filterTable = [];
    /*this.gridColConfig.forEach(c => {      
      if(c.filter != false){  
        this.filterTable.push(
          {
            field: c.field,
            value: '',
          }
        );
      }
        console.log(this.filterTable);
    });*/

    if (this.tableOptions!.notLazy != true) {
      let o = 1;
      let ps = 25;
      let ofs = (o - 1) * (ps);
      this.getDataLazy(ofs, ps, 1, this.filterTable, this.sortTaable);

    } else {
      this.getDataNotLazy(this.filterTable, this.sortTaable);
    }




  }



  ngOnChanges(changes: { options: SimpleChange, dataSource: SimpleChange, pageSettings: SimpleChange, tableOptions: SimpleChange, filterTable: SimpleChange, gridColConfig: SimpleChange }): void {
    if (changes.gridColConfig) {
      //this.resetTable();
    }
    // console.warn(" \n \n \n changes detected");
    // console.log(changes);
    // if(changes.options){
    //   let o = this.pageSettings!.currentPage || 1;
    //   let ps = this.pageSettings!.pageSize || 25;
    //   let ofs = (o-1) * (ps);
    //   this.getDataLazy(ofs,ps,1);
    //   this.refreshTable()
    // }
    // /*if(changes.dataSource) {
    //   console.log("\n \n \n Data source changed ?");
    //   if(//this.tableEl != undefined) {
    //     //this.tableEl.dataSource = changes.dataSource.currentValue;
    //     //this.tableEl.refresh();
    //     console.log("\n yes it changed");
    //   }
    //   //this.tableEl!.dataSource = changes.dataSource.currentValue;
    //   this.onDataSourceChange.emit(changes.dataSource.currentValue);
    // }*/


    // if(changes.pageSettings) {
    //   if(//this.tableEl != undefined) {
    //     ////this.tableEl!.pageSettings = this.pageSettings || this.pageSettingsDefault;
    //     this.parsePage(changes.pageSettings.currentValue);
    //   }
    // }




    // if(changes.tableOptions){
    //   this.parseOptions(changes.tableOptions.currentValue);
    //   let o = this.pageSettings!.currentPage || 1;
    //   let ps = this.pageSettings!.pageSize || 25;
    //   let ofs = (o-1) * (ps);
    //   this.getDataLazy(ofs,ps,1);

    //   if(//this.tableEl != null || //this.tableEl != undefined) {
    //     //this.tableEl!.pageSettings = this.pageSettings || this.pageSettingsDefault;
    //   }


    //   this.parsePage(this.pageSettings || this.pageSettingsDefault);
    //   if(this.pageSettings != undefined || this.pageSettings != null) {
    //     this.pageSettingsDefault = this.pageSettings;
    //   }
    // }

    // //this.tableEl?.refresh()
  }

  getImagePath(data: GridColConfig): string {
    return (data.fieldOptions as CustomGridImg).path;
  }

  // button
  getButtuonIcon(data: GridColConfig): string | undefined {
    return (data.fieldOptions as CustomGridButton)?.icon || undefined;
  }

  getButtonLabel(data: GridColConfig): string | undefined {
    return (data.fieldOptions as CustomGridButton)?.label || undefined;
  }

  getButtonAlign(data: GridColConfig): string | undefined {
    return (data.fieldOptions as CustomGridButton)?.align || undefined;
  }

  // color
  getColorHeight(data: GridColConfig): string {
    return (data.fieldOptions as CustomGridColor).height;
  }

  getColorWidth(data: GridColConfig): string {
    return (data.fieldOptions as CustomGridColor).width;
  }

  parseOptions(options: CustomgridOptions) {
    this.parsedOption = _.cloneDeep(options);
    // if (this.tableEl != undefined) {
    //   //this.tableEl.refresh();
    // }
  }

  parseData(data: BaseGridResponse) {
    this.parsedData = _.cloneDeep(data)
    console.log(this.parsedData)
    // if (this.tableEl != undefined) {
    //   //this.tableEl.dataSource = data;
    // }

    // setTimeout(()=>{
    //   if(data==null){
    //     this.parsedData=[];
    //   }
    // },10)


  }

  checkFilters(e: any) {

    this.showFilter = !this.showFilter;
    console.warn("\n \n this are the filters \n \n");
    console.warn(this.filterTable);
    this.filterTable.forEach((x, index) => {

      if (x.field == e.target.id) {
        this.filterTable[index].filterValue = e.target.value
      }
    })
    console.log("Dati da inviare");
    console.log();


    // imposto variabile per sorting

    // se ci sono ordinamenti aggiungo campi
    if (e.columnName != undefined) {
      this.sortTaable = [];
      this.sortTaable.push(
        {
          field: e.columnName,
          direction: e.direction,
        },
      );
      console.log("Dati sorting");
      console.log(this.sortTaable);
    } else {
      this.sortTaable = [];
    }

    if (this.tableOptions!.notLazy != true) {
      //this.tableEl?.goToPage(1);
      let o = 1;
      let ps = 25;
      let ofs = (o - 1) * (ps);



      this.getDataLazy(ofs, ps, o, this.filterTable, this.sortTaable);
    } else {
      this.getDataNotLazy(this.filterTable, this.sortTaable);
    }

  }

  sortChange(event: Sort) {
    console.log(event)
    if (event.direction.toString().length > 0) {

      this.sortTaable = [{
        field: event.active,
        direction: event.direction.toString()
      }]
    } else {
      this.sortTaable = [];
    }

    this.paginator.firstPage();
    this.getDataLazy(0, this.paginator.pageSize, this.paginator.pageIndex, this.filterTable, this.sortTaable);
  }

  onKeyPress(e: any) {
    console.log(e)
  }


  //SPOSTA IL SORTING DENTRO IL NUOVO EVENTO

  /*******************************************************************************************  azioni lazy loading **************************************************/
  /**
   * Actions executed on row selection
   * @param e any
   */
  rowSelected(e: any) {
    this.onRowSelect.emit(e);
  }


  switchChange(event: any, data: any) {
    let d: object = {
      event: event,
      data: data,
    }
    this.onSwitchChange.emit(d);
  }


  dropdownChange(event: any, data: any) {
    let d: object = {
      event: event,
      data: data,
    }
    this.onDropdownChange.emit(d);
  }

  checkBoxChange(event: any, data: any) {
    let d: Object = {
      event: event,
      data: data,
    };
    this.onCheckBoxChange.emit(d);
  }

  emitActionComplete(event: any) {
    console.warn(event)
    this.onActionComplete.emit(event);
  }

  rowDB(event: any) {
    this.onRowDataBound.emit(event);
  }

  emitBtnClick(data: any, event: any, name: any) {
    let d: Object = {
      action: event.toString().toLowerCase(),
      name: name,
      data: data,
    }
    console.warn("Button clicked");
    console.warn(d);
    this.onButtonClick.emit(d);
  }


  pageChanged(event: PageEvent) {
    let offset = event.pageSize * event.pageIndex;
    let max = event.pageSize;
    let currentPage = event.pageIndex
    this.getDataLazy(offset, max, currentPage, this.filterTable, this.sortTaable)
  }

  getDataLazy(offset: number, max: number, currentPage?: number, filter?: customFilterListModel[], sort?: CustomGridSorting[]) {

    if (this.tableOptions?.noApiCalls == true) {
      return;
    }

    //this.tableEl?.showMaskRow();
    this.loading = true;

    document.getElementById('scrollTop')?.scrollIntoView({ behavior: 'smooth' });

    // if(//this.tableEl != undefined) {
    //   //this.tableEl!.dataSource = [];
    // }

    if (this.tableOptions!.notLazy != true) {
      this.customGridService.getLazyData(this.tableOptions!.apiCallurl, offset, max, filter, sort).pipe(takeUntil(this.theEnd$)).subscribe({
        next: (data: BaseGridResponse) => {
          this.dataSource = data.result;
          this.gridDataSource.data = data.result;
          this.totalRows = data.count ?? this.gridDataSource.data.length;
          this.parsedData = _.cloneDeep(data)


          let idbData: GridStatusIdb = {
            currentPage: currentPage ?? 1,
            filters: _.cloneDeep(this.filterTable)
          }

          if (this.tableOptions?.gridName) {

            this.idb.addItemRow(environment.idbTables.GridStatus, idbData, `${this.tableOptions.gridName}-${this.currentSession}`);
            console.log("🚀 ~ file: custom-grid.component.ts:889 ~ CustomGridComponent ~ this.customGridService.getLazyData ~ this.session:", this.currentSession)
          }

          //this.tableEl?.hideSpinner();
          this.loading = false;



        },
        error: (e: any) => {
          console.error("Could not get any data!!");
        },
        complete: () => {
          this.onActionComplete.emit("");
        }
      });
    }
  }


  getDataNotLazy(filter?: customFilterListModel[], sort?: CustomGridSorting[]) {

    if (this.tableOptions?.noApiCalls == true) {
      return;
    }

    //this.tableEl?.showMaskRow();
    this.loading = true;

    document.getElementById('scrollTop')?.scrollIntoView({ behavior: 'smooth' });

    // if(//this.tableEl != undefined) {
    //   //this.tableEl!.dataSource = [];
    // }


    this.customGridService.getDataNoLazy(this.tableOptions!.apiCallurl, filter, sort).pipe(takeUntil(this.theEnd$)).subscribe({
      next: (data: any) => {
        this.dataSource = data;
        this.gridDataSource.data = data;
        this.totalRows = data.count;
        this.parsedData = _.cloneDeep(data)


        let idbData: GridStatusIdb = {
          currentPage: 0,
          filters: _.cloneDeep(this.filterTable)
        }

        if (this.tableOptions?.gridName) {

          this.idb.addItemRow(environment.idbTables.GridStatus, idbData, `${this.tableOptions.gridName}-${this.currentSession}`);
          console.log("🚀 ~ file: custom-grid.component.ts:889 ~ CustomGridComponent ~ this.customGridService.getLazyData ~ this.session:", this.currentSession)
        }

        //this.tableEl?.hideSpinner();
        this.loading = false;



      },
      error: (e: any) => {
        console.error("Could not get any data!!");
      },
      complete: () => {
        this.onActionComplete.emit("");
      }
    });

  }


  //display column chooser
  showChooser() {
    let div = document.getElementById('chooserButton');

    //this.tableEl?.columnChooserModule.openColumnChooser(300, 30);
    /*   div?.focus();
      div?.blur(); */
  }



  /**
   * Push data in to the grid
   */
  refreshTable() {
    /*//this.tableEl!.addRecord(e);
    //this.tableEl!.refresh();*/
    console.log("refreshing")
    if (this.tableOptions!.notLazy != true) {
      console.log("refreshing")
      let o = 1;
      let ps = 25;
      let ofs = (o - 1) * (ps);
      this.getDataLazy(ofs, ps, 1, this.filterTable, this.sortTaable);
    } else {
      this.getDataNotLazy(this.filterTable, this.sortTaable);
    }
  }

  hasNoData = (index: number, item: any) => {
    return this.gridDataSource.data.length === 0;
  };


  setData(data: Array<any>) {
    //this.tableEl!.dataSource = data;
  }

  /*setExcelExportOnGrid() {
    //this.tableEl?.allowExcelExport = true;
  }*/

  /**
   * Trigger on every cell selct // after the cell is selectd
   * @param event any 
   */
  //GridCheckBoxChangeData
  gridCheckboxChange(event: GridCheckBoxChangeData) {
    let checkedDataArray: any[] = [];
    if (this.parsedOption?.notLazy == undefined || this.parsedOption.notLazy == false) {
      if (this.parsedData != undefined && this.parsedData.result != undefined) {
        event.selectedRowIndexes.forEach(val => {
          checkedDataArray.push(this.parsedData?.result[val]);
        });
      }
    }
    let dataPush: GridRowCheckboxChangeData = {
      data: checkedDataArray,
      event: event,
    };
    this.onGridCheckBoxChange.emit(dataPush);
  }

  ///return date as value

  returnDate(input: string): Date {
    return new Date(input);
  }

  queryCellInfo(event: any) {
    this.onQueryCellInfo.emit(event);
  }



  // edit row
  startRowEdit(event: any) {
    console.warn("About to start row edit");
    //this.tableEl?.startEdit();
  }


  getSVG(svg: any) {
    return btoa(svg)
  }

  getCorrectDecimal(value: any): string {
    return this.globalService.formatDecimalToComma(value).replace(',00', '');
  }

  isNumber(value: any): boolean {
    return typeof value === 'number';
  }


  toggleFilters() {
    this.showFilter = !this.showFilter;
  }
  exportCsv() {
    throw new Error('Method not implemented.');
  }
  applyFilter($event: KeyboardEvent) {
    throw new Error('Method not implemented.');
  }
  isAllSelected(): unknown {
    throw new Error('Method not implemented.');
  }
  masterToggle() {
    throw new Error('Method not implemented.');
  }
  onRowClicked(_t90: any) {
    throw new Error('Method not implemented.');
  }
}
